export function getUniqueArray<T>(list: T[]): T[] {
  return Array.from(new Set(list));
}
